<div class="list-header">
  <div class="hide-handheld flex flex-row justify-between w-full items-center">
    <h2 class="pl-2 text-white">KPI Dashboard</h2>
  </div>
</div>

<div class="p-6">
  <div class="grid grid-cols-2 gap-2 pb-2">
    <div class="flex-1">
      <span class="font-bold text-xl">Region </span>
      <span class="pr-2"><sa-region-selector></sa-region-selector></span>
      <span><sa-frac-selector></sa-frac-selector></span>
    </div>
  </div>

  <sa-stats></sa-stats>

  <div class="grid grid-cols-2 gap-2 pb-2">
    <sa-time-to-npt></sa-time-to-npt>

    <sa-driver-with-completed-loads></sa-driver-with-completed-loads>

    <sa-average-turn-rate></sa-average-turn-rate>

    <sa-pending-load-by-hour></sa-pending-load-by-hour>

    <sa-pump-volume-stats></sa-pump-volume-stats>
  </div>

  <div class="grid grid-cols-1 pb-2">
    <sa-fracs-stats></sa-fracs-stats>
  </div>

  <div class="grid grid-cols-1 pb-2">
    <sa-carrier-stats></sa-carrier-stats>
  </div>
</div>
